module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.fcfe287.woff2";